import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { App as AntApp } from "antd";
import { initDebugFloatFromUrl } from "./utils/debugFloatEnabled";
import { registerChunkLoadRecovery } from "./utils/chunkLoadRecovery";

initDebugFloatFromUrl();
registerChunkLoadRecovery();

// 对 touchstart/touchmove/wheel 的监听默认使用 passive: true，避免第三方库（如 antd）
// 未标记 passive 时触发的 Chrome [Violation] 警告，提升滚动流畅度。
(function ensurePassiveScrollListeners() {
  let supportsPassive = false;
  try {
    const opts = Object.defineProperty({}, "passive", {
      get() {
        supportsPassive = true;
        return false;
      },
    });
    globalThis.addEventListener("test", null as any, opts);
    globalThis.removeEventListener("test", null as any, opts);
  } catch {
    // ignore
  }
  if (!supportsPassive) return;
  const passiveEventTypes = new Set([
    "touchstart",
    "touchmove",
    "wheel",
    "mousewheel",
  ]);
  const originalAddEventListener = EventTarget.prototype.addEventListener;
  EventTarget.prototype.addEventListener = function (
    type: string,
    listener: EventListenerOrEventListenerObject | null,
    options?: boolean | AddEventListenerOptions
  ) {
    if (passiveEventTypes.has(type.toLowerCase())) {
      const optObj =
        typeof options === "object" && options !== null ? options : {};
      const passive = "passive" in optObj ? optObj.passive !== false : true;
      const opts = { ...optObj, passive };
      return originalAddEventListener.call(this, type, listener, opts);
    }
    return originalAddEventListener.call(this, type, listener, options);
  };
})();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <AntApp>
      <App />
    </AntApp>
  </React.StrictMode>
);
